module.exports = __webpack_public_path__ + "img/13.99b74dbc.png";